import React from 'react';
import { X } from 'react-feather';
import { Button } from '../../../../../ui';
import './SideDrawer.scss';

interface SideDrawerProps {
  /** Accessible name for the panel. */
  label: string;
  onClose: () => void;
  /** Summary shown in the fixed header (e.g. a DescriptionList). */
  header?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}

/**
 * Right-hand detail panel that slides over the page. The caller controls mounting
 * (render it only while open). No backdrop: the page underneath stays interactive.
 */
const SideDrawer: React.FC<SideDrawerProps> = ({ label, onClose, header, children, className }) => (
  <aside className={['ds-drawer', className].filter(Boolean).join(' ')} role="dialog" aria-label={label}>
    <div className="ds-drawer__header">
      <div className="ds-drawer__summary">{header}</div>
      <Button variant="ghost" size="sm" onClick={onClose} aria-label="Close" icon={<X size={18} aria-hidden />} />
    </div>
    <div className="ds-drawer__body">{children}</div>
  </aside>
);

export default SideDrawer;
